import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 22L12 2L22 22H2ZM12.5999 9.9999C12.5999 9.66853 12.3313 9.3999 11.9999 9.3999C11.6685 9.3999 11.3999 9.66853 11.3999 9.9999V14.9999C11.3999 15.3313 11.6685 15.5999 11.9999 15.5999C12.3313 15.5999 12.5999 15.3313 12.5999 14.9999V9.9999ZM11.9999 17.3999C11.3924 17.3999 10.8999 17.8924 10.8999 18.4999C10.8999 19.1074 11.3924 19.5999 11.9999 19.5999C12.6074 19.5999 13.0999 19.1074 13.0999 18.4999C13.0999 17.8924 12.6074 17.3999 11.9999 17.3999Z",
		fill: "currentColor"
	})
});
export default SvgWarningFill;
